import React from 'react';
// Import images


const CtaTwo = () => {
  return (
    <>
    {/*CTA One Start*/}
    <section className="cta-one">
    <div className="container">
      <div className="cta-one__inner">
        <h3 className="cta-one__title">
          Get Latest Updates Subscribe <br /> to Our Newsletter
        </h3>
        
      </div>
    </div>
    </section>
    {/*CTA One End*/}
    </>
  );
};

export default CtaTwo;
